import { Center, Image, Text } from '@chakra-ui/react';
import * as React from 'react';

export const GroupIcon: React.FC<{
  name: string;
  url: string | null;
}> = (props) => {
  return props.url ? (
    <Image
      width="1em"
      height="1em"
      src={props.url}
      alt=""
      fit="cover"
      borderRadius="base"
    />
  ) : (
    <Center width="1em" height="1em" bg="gray.200" borderRadius="base">
      <Text fontSize="sm">
        {props.name.length > 0 && props.name.substring(0, 1)}
      </Text>
    </Center>
  );
};
